import { useMemo } from 'react';
import { useAssigneeFilter } from '../../../hooks/useAssigneeFilter';
import type { DmNotificationFilters } from '../../../services/dmNotifications';
import { ASSIGNEE_NULL_SENTINEL } from '../../../utils/assigneeFilter';
import { tagsToVersions } from '../shared/inboxTags';
import { levelFilterToApi } from './dmNotificationLevels';
import type { NotificationListParams } from './notificationListParams';

type FilterSource = Omit<NotificationListParams, 'mode'>;

// The list's UI values as the API takes them: unknown levels and tags dropped, "Me" to an email.
export function useNotificationApiFilters(
    { search, levels, practiceIds, assignees, tags, status, sort, order }: FilterSource,
    onAssigneesMigrate?: (values: string[]) => void
) {
    const {
        options: assigneeOptions,
        apiValues: apiAssignees,
        settled: assigneesResolved
    } = useAssigneeFilter(assignees, ASSIGNEE_NULL_SENTINEL, onAssigneesMigrate);
    const apiLevels = useMemo(() => levelFilterToApi(levels), [levels]);
    const versions = useMemo(() => tagsToVersions(tags), [tags]);
    const apiFilters: DmNotificationFilters = {
        sort,
        order,
        search: search || undefined,
        levels: apiLevels,
        practiceIds,
        assignees: apiAssignees,
        versions,
        status
    };
    return { apiFilters, assigneeOptions, assigneesResolved };
}
